import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdateFirestopItem = async (
  projectId,
  firestopItemId,
  firestopItemAttributeModifications,
  firestopImagesToAdd,
  firestopImagesToDelete
) => {
  const apiPath = `firestop-documentation/project/${projectId}/firestop/${firestopItemId}/update-firestop-item`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {
      firestopItemAttributeModifications,
      firestopImagesToAdd,
      firestopImagesToDelete,
    },
  });

  const response = await axios(signedRequest);

  return response.data;
};
